export default "__VITE_ASSET__DC5IRYoI__"